import { API } from './resources'

export default {
  getUserPin: (username) => {
    return API.get(`/user/${username}/pin`)
  },
  update: (pinURL, username) => {
    return API.put(`/user/${username}/pin`, { url: pinURL })
  },
  getPins: (username, limit, offset, count) => {
    return API.get(`/user/${username}/pins`, { params: { limit, offset, count } })
  },
  sendSwapRequest: (sendingUser, receivingUser) => {
    return API.post(`/pin/swap/${sendingUser}/${receivingUser}`)
  },
  getUserHasSwapped: (viewingUser, viewedUser) => {
    return API.get(`/pin/swapped/${viewingUser}/${viewedUser}`)
  },
  getUserHasCollected: (viewingUser, viewedUser) => {
    return API.get(`/pin/collected/${viewingUser}/${viewedUser}`)
  },
  updatePinOrder: (userPinIDs) => {
    return API.put('/user/pins/reorder', { userPinIDs })
  },
  collectPin: (boothOwner) => {
    return API.post(`/user/collect/${boothOwner}`)
  }
}
